import { formValueSelector } from 'redux-form';

import { getBasketFormName } from '@utils/basket/addToBasket';
import { isGuestAlreadyInArray } from '@utils/helpers';

export const basketSelectors = {
  getIsBasketDetailsFetching: (state) => state.basket.isBasketDetailsFetching,
  getBasketDetails: (state) => state.basket.basketDetails,
  promoCodeFailure: (state) => state.basket.promoCodeFailure,
  getBasketPricing: (state) => state.basket.basketPricing,
  getReservedSpaTimeSlots: (state) =>
    state.basket.basketDetails.items
      .filter((item) => item.type === 'spa-days')
      .map((item) => item.checkIn),
  getBasketItemCount: (state) => {
    if (!state?.basket?.basketDetails) {
      return 0;
    } else {
      const nonPackageItems = state.basket.basketDetails.items.filter(
        (item) => !item.dynamicPackage
      );
      const packageItems = state.basket.basketDetails.items.filter(
        (item) => item.dynamicPackage === 'parent'
      );
      const nonPackageItemsCount = (nonPackageItems || []).reduce((count, item) => {
        return count + item.quantity;
      }, 0);
      return nonPackageItemsCount + packageItems.length;
    }
  },
  getBasketErrors: (state) => state.basket.errors,
  getOrder: (state) => state.basket.order,
  getIsOrderCreateFetching: (state) => state.basket.isOrderCreateFetching,
  getIsOrderFetching: (state) => state.basket.isOrderFetching,
  getOrderCreateError: (state) => state.basket.orderCreateError,
  getOrderFetchError: (state) => state.basket.orderFetchError,
  getOrderStatusError: (state) => state.basket.orderStatusError,
  getOrderStatusUnknown: (state) => state.basket.orderStatusUnknown,
  getIsOrderStatusUpdating: (state) => state.basket.isOrderStatusUpdating,
  getIsPaymentOptionUpdating: (state) => state.basket.isPaymentOptionUpdating,
  getPaymentOptionError: (state) => state.basket.paymentOptionError,
  getOrderPaymentDetails: (state) => state.basket.order.orderStatus?.moneyTransfers?.[0],
  getBasketGuests: (state) => {
    if (state.basket && state.basket.basketDetails && state.basket.basketDetails.items) {
      return state.basket.basketDetails.items.reduce((basketGuests, item) => {
        if (item.guestDetails) {
          item.guestDetails.forEach((guest) => {
            if (!isGuestAlreadyInArray(basketGuests, guest)) {
              basketGuests.push({
                id: guest.id,
                firstName: guest.firstName,
                lastName: guest.lastName,
                title: guest.title,
                gender: guest.gender,
                externalSpaId: guest.externalSpaId,
              });
            }
          });
        }
        return basketGuests;
      }, []);
    }
    return [];
  },
  getBasketFormSelector: (itemId) => formValueSelector(getBasketFormName(itemId)),
};
